import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { Constant } from 'src/app/constant/constant';
import { CrmNoteService } from 'src/app/services/crm-note.service';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import { DynamicFormLabelService } from 'src/app/services/dynamic-form-label.service';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { LeadService } from 'src/app/services/lead.service';
import { ProductService } from 'src/app/services/product.service';
import { environment } from 'src/environments/environment';
import { CallListComponent } from '../../call-list/call-list.component';
import { ConversationPopupComponent } from '../../conversation-popup/conversation-popup.component';
import { CrmNoteComponent } from '../../crm-note/crm-note.component';
import { SearchBuilderComponent } from '../../search-builder/search-builder.component';
import { TransferLeadComponent } from '../../transfer-lead/transfer-lead.component';
import { downloads } from '../../utils/calsoft-validators';
import { Location } from '@angular/common';
import { Validators } from '@angular/forms';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
@Component({
  selector: 'calsoft-popup-leadstatus',
  templateUrl: './popup-leadstatus.component.html',
  styleUrls: ['./popup-leadstatus.component.scss']
})
export class PopupLeadstatusComponent implements OnDestroy {

  sanitizedUrl: string = '';

  private _onDestroy = new Subject<void>();
  url = '';


  @Input() incomingId: any = '';
  @Input() popupType: any = 1;
  minDate: Date = new Date();
  @Output() closePopup = new EventEmitter();
  callclosepopup() {
    this.closePopup.emit(true)
  }
  priorities: string[] = ['High', 'Medium', 'Low'];
  selectedPriority: string = '';
  updatePriority(prior) {
    this.selectedPriority = this.priorities[prior];
  }

  leadActivityList: any = [];

  init: boolean = false;

  @Input() LeadDetailsObject: any;
  leadId: any;

  public editMode = false;
  leadStatusList: any;

  public selectedLeadStatus: string;
  text: string;
  textSave: string;

  leadAge: string;
  textAccount: string;
  leadPropertiesName: any;
  leadAdditionalPropertiesName: any;
  leadCommonPropertiesName: any;
  leadNoteDisplay: any;
  leadAdditionalPropertiesDisplay: any;
  leadCommonPropertiesDisplay: any;
  leadPropertiesDisplay: any;
  additionalSpec: any;
  filterList: any;

  noteList: any = [];
  usedInSite: any;
  jsonRecieved: any;
  id: any;
  activityId: any;
  textCall: string;
  ownerId: any;
  type1: boolean = false;
  additionalSpecList: any = [];
  type2: boolean = false;
  valuesList: any = [];
  type3: boolean = false;
  customList: any = [];
  crmType: any;
  dialerShow: boolean;
  customField1: any;
  additionalData: boolean = false;
  additionalAttributeName: any;
  additionalAttributeEnable: any = 0;
  enableInvoiceInLead: any = 0;
  newType: number = 1;
  customField10: any;
  finalValueForm: any = {};
  patchValues: any;
  formInit: boolean = false;
  sameLeadName: boolean;
  emailValue: any;
  phoneValue: any;

  constructor(private route: ActivatedRoute,
    private leadActivityService: LeadActivityService,
    private dialog: MatDialog,
    private ecryptService: EcryptServiceService,
    private leadStatusService: LeadStatusService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private leadService: LeadService,
    private crmsettingsService: CrmsettingsService,
    private crmNoteService: CrmNoteService,
    private productService: ProductService,
    public location: Location,
    private router: Router,
    private dynamicFormLabelService: DynamicFormLabelService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }


  public serverPath = environment.commonImageApi + '/courseAudio/';

  public serverPathImage = environment.commonImageApi + 'courseImage/';

  public serverPathPdf = environment.commonImageApi + 'coursepdf/';

  public serverPathVedio = environment.commonImageApi + '/courseVideo/';

  ngOnInit(): void {

    this.leadId = this.incomingId;
    this.text = 'Submit';
    this.textSave = 'Save'
    this.createFormGroup();
    this.getAllLeadDetails(this.incomingId)
    this.textAccount = 'OK';
    this.textCall = 'Call'
    this.getAllCrmData();
    this.typeYFilter();
    this.getLeadDropDownList();
    this.dialerShow = false;

  }




  openCallDialog() { }

  closeDialog() {
    this.dialog.closeAll();
  }

  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        this.leadPropertiesName = data['leadPropertiesName'];
        this.leadAdditionalPropertiesName = data['leadAdditionalPropertiesName'];
        this.leadCommonPropertiesName = data['leadCommonPropertiesName'];
        this.leadNoteDisplay = data['leadNoteDisplay'];
        this.leadAdditionalPropertiesDisplay = data['leadAdditionalPropertiesDisplay'];
        this.leadCommonPropertiesDisplay = data['leadCommonPropertiesDisplay'];
        this.leadPropertiesDisplay = data['leadPropertiesDisplay'];
        this.crmType = data['crmType'];
        this.additionalAttributeName = data['additionalAttributeName'];
        this.additionalAttributeEnable = data['additionalAttributeEnable'];
        this.enableInvoiceInLead = data['enableInvoiceInLead'];


      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }


  calculateLeadAge(): void {
    const createdDate = new Date(this.LeadDetailsObject.createdDate);

    //console.log(createdDate);

    const currentDate = new Date();
    const timeDiff = Math.abs(currentDate.getTime() - createdDate.getTime());
    const days = Math.floor(timeDiff / (1000 * 3600 * 24));


    if (days === 0) {
      this.leadAge = `${days} Days`;
    } else {
      this.leadAge = `${days} Day${days !== 1 ? 's' : ''} Ago`;
    }

    //console.log(this.leadAge);

  }


  getAllLeadActivity(leadId) {
    this.init = false;
    this.leadActivityService.getAllLeadActivityByLeadId(leadId).subscribe(
      data => {

        this.leadActivityList = data;

        this.init = true;

        // console.log(this.leadActivityList);
      },
      error => {

      })
  }

  firstFormGroup: FormGroup;

  toggleEditMode(field: string) {
    switch (field) {
      case 'Name':
        this.editModeName = !this.editModeName;
        break;
      case 'Email':
        this.editModeEmail = !this.editModeEmail;
        break;
      case 'PhoneNumber':
        this.editModePhoneNumber = !this.editModePhoneNumber;
        break;
    }
  }

  createFormGroup() {
    this.firstFormGroup = this.fb.group({
      CallDuration: [''],
      Country: [''],
      CreatedBy: [''],
      Description: [''],
      DoNotCall: [''],
      DoNotEmail: [''],
      Email: [''],
      LeadSource: [''],
      LeadStatus: [''],
      Name: [''],
      notes: [''],
      Owner: [''],
      PhoneNumber: [''],
      ReceiverMobile: [''],
      Address: [''],
      CrNo: [''],
      CrName: [''],
      priority: ['Medium'],
      collegeName: [''],
      remarks: [''],
      branch: [''],
      followUpDate: ['', Validators.required],
      followUpTime: [''],
      followUpDateTime: ['', Validators.required],
      secondaryphoneno: [''],
    });
  }


  editformGroup(leadset: any) {
    this.emailValue = leadset.email;
    this.phoneValue = leadset.phoneNumber;

    const parsed = this.parseFollowUpDateTime(leadset.followUpDateTime);
    const existingTime = parsed.time || this.toTime24(leadset.followupTime || leadset.followUpTime || '');
    const isNotInterested = (leadset.statusName || '').trim().toLowerCase() === 'not intrested';

    this.firstFormGroup = this.fb.group({
      CallDuration: leadset.callDuration,
      Country: leadset.Country,
      CreatedBy: leadset.createdBy,
      Description: leadset.description,
      DoNotCall: leadset.doNotCall,
      DoNotEmail: leadset.doNotEmail,
      Email: leadset.email,
      LeadSource: leadset.sourceId,
      LeadStatus: leadset.statusId,
      Name: leadset.name,
      notes: leadset.notes,
      Owner: leadset.Owner,
      PhoneNumber: leadset.phoneNumber,
      ReceiverMobile: leadset.ReceiverMobile,
      statusName: leadset.statusName,
      sourceName: leadset.sourceName,
      statusReason: leadset.statusReason,
      Address: leadset.address,
      CrNo: leadset.CrNo,
      CrName: leadset.CrName,
      priority: leadset.priority == null ? 'Medium' : leadset.priority,
      collegeName: leadset.collegeName,
      remarks: leadset.remarks,
      branch: leadset.branch,
      followUpDate: [parsed.date, isNotInterested ? [] : [Validators.required]],
      followUpTime: [existingTime],
      followUpDateTime: [leadset.followUpDateTime == null ? null : leadset.followUpDateTime],
      secondaryphoneno: leadset.secondaryphoneno
    })

    let finalObject = { ... this.customField10, ... this.firstFormGroup.value };

    this.patchValues = finalObject;

    this.getLeadStatus();
  }


  getAllLeadDetails(leadId) {

    let data = this.LeadDetailsObject;

    this.LeadDetailsObject = data

    this.customField1 = this.LeadDetailsObject?.customField1;

    this.customField10 = this.LeadDetailsObject?.customField10;


    if (this.LeadDetailsObject.ast != null) {
      const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.LeadDetailsObject.ast));
      this.type1 = true;
      this.additionalSpecList = keyValuePairs;
      this.additionalSpec = JSON.parse(this.LeadDetailsObject.ast);
    } else {

      this.additionalSpec = this.LeadDetailsObject.additionalSpec;

    }


    if (this.LeadDetailsObject.valuesString != null) {
      const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.LeadDetailsObject.valuesString));
      this.type2 = true;
      this.valuesList = keyValuePairs;
      this.filterList = JSON.parse(this.LeadDetailsObject.valuesString);
    } else {
      this.filterList = this.LeadDetailsObject.values;
    }

    if (this.LeadDetailsObject.isCustomizedValueString != null) {
      const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.LeadDetailsObject.isCustomizedValueString));
      this.type3 = true;
      this.customList = keyValuePairs;
      this.usedInSite = JSON.parse(this.LeadDetailsObject.isCustomizedValueString);
    } else {
      this.usedInSite = this.LeadDetailsObject.isCustomizedValue;
    }

    this.jsonRecieved = this.LeadDetailsObject.jsonRecieved;
    this.ownerId = data['ownerId'];

    this.editformGroup(this.LeadDetailsObject);

    this.calculateLeadAge();

    console.log(this.firstFormGroup);

  }



  addLeadActivity(activityType: string, activityId, leadObject: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "lead",
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "taskSaveType": 1
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          this.getAllLeadActivity(this.leadId);

        }



      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "lead",
          "taskSaveType": 1
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          this.getAllLeadActivity(this.leadId);

        }


      });
    }

  }


  transferLead() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(TransferLeadComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "ownerId": this.ownerId,
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getAllLeadDetails(this.leadId);
          this.getAllLeadActivity(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(TransferLeadComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "ownerId": this.ownerId,
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getAllLeadDetails(this.leadId);
          this.getAllLeadActivity(this.leadId);
        }

      });
    }
  }


  newSearch(LeadDetailsObject) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(SearchBuilderComponent, {
        width: '790px',
        disableClose: true,
        data: { data: LeadDetailsObject }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
      });

    }
    else {
      let dialogRef = this.dialog.open(SearchBuilderComponent, {
        minWidth: '100vw', height: '100vh',
        data: { data: LeadDetailsObject }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {

      });
    }
  }


  currentStatusName: any;

  editForm() {

    this.formInit = false;
    let index = this.leadStatusList.findIndex(x => x.statusId === this.firstFormGroup.value.LeadStatus);
    if (index > -1) {
      this.patchValues.LeadStatus = this.firstFormGroup.value.LeadStatus;

      this.currentStatusName = this.leadStatusList[index].statusName;



      if (this.currentStatusName == 'Not intrested') {
        this.firstFormGroup.get('followUpDate')?.clearValidators();
        this.firstFormGroup.patchValue({
          followUpDate: null,
          followUpTime: '',
          followUpDateTime: ''
        });
      } else {
        this.firstFormGroup.get('followUpDate')?.setValidators([Validators.required]);
        this.firstFormGroup.patchValue({
          followUpDate: this.firstFormGroup.value.followUpDate,
          followUpTime: this.firstFormGroup.value.followUpTime,
          followUpDateTime: this.firstFormGroup.value.followUpDateTime
        });
      }
      this.firstFormGroup.get('followUpDate')?.updateValueAndValidity();


      this.getcreateDynamicForm(this.leadStatusList[index].dynamicFormGroupId);
    }
    this.editMode = !this.editMode;


  }


  save() {

  }

  close() {
    this.editMode = false;
  }

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'statusId' + "," + Constant.Dsc;

  type: any = 0;

  getLeadStatus() {
    this.leadStatusService.LeadStatus(this.page, this.size, this.sortParam, this.type).subscribe(
      res => {
        this.leadStatusList = res['content'];
        this.editForm();
      },
      error => {
        console.log("Error fetching Lead Status", error);
      }
    );
  }

  checkLeadExist() {


    if (this.firstFormGroup.valid) {

      this.textSave = "Processing"

      if (
        (this.emailValue !== this.firstFormGroup.value.Email ||
          this.phoneValue !== this.firstFormGroup.value.PhoneNumber)
      ) {
        const payload = {
          Email: this.firstFormGroup.value.Email,
          PhoneNumber: this.firstFormGroup.value.PhoneNumber,
          entityId: this.leadId,
        };

        this.leadService.leadAlreadyExist(payload).subscribe(
          (response) => {
            if (response['status_code'] === Constant.RESPONSE_SUCCESS) {

              this.sameLeadName = true;
              this.saveLead();
              this.textSave = "Processing"
            } else {
              this.textSave = 'Save';
              this.snackBar.open(response['data']['message'], '×', {
                panelClass: 'error',
                verticalPosition: 'bottom',
                duration: 500,
              });
            }
          },
          (err) => {
            this.textSave = 'Save';
            this.sameLeadName = true;
          }
        );

        return this.sameLeadName;
      } else {
        this.saveLead();
      }
    } else {
      this.firstFormGroup.markAllAsTouched();

      this.snackBar.open("Form is invalid. Please check all required fields.", '×', {
        panelClass: 'error',
        verticalPosition: 'bottom',
        duration: 3000
      });
    }

  }


  editModeName = false;
  editModeEmail = false;
  editModePhoneNumber = false;


  saveLead() {
    this.textSave = "Processing"

    const combinedFollowUp = this.getCombinedFollowUpDateTime();

    let object = {
      "LeadStatus": this.firstFormGroup.value.LeadStatus,
      "entityId": this.leadId,
      "Name": this.firstFormGroup.value.Name,
      "Email": this.firstFormGroup.value.Email,
      "PhoneNumber": this.firstFormGroup.value.PhoneNumber,
      "Address": this.firstFormGroup.value.Address || '',  // Handle null/undefined with fallback value
      "CrNo": this.firstFormGroup.value.CrNo || '', // Handle null/undefined
      "CrName": this.firstFormGroup.value.CrName || '',
      "collegeName": this.firstFormGroup.value.collegeName,
      "remarks": this.firstFormGroup.value.remarks,
      "branch": this.firstFormGroup.value.branch,
      "notes": this.firstFormGroup.value.notes,
      "followUpDateTime": combinedFollowUp,
      "secondaryphoneno": this.firstFormGroup.value.secondaryphoneno
    }

    delete this.finalValueForm['LeadStatus'];
    let finalObject = { ...object, ...this.finalValueForm };

    const firstValue = Object.values(this.finalValueForm)[0];


    if (combinedFollowUp == null) {
      delete finalObject['followUpDateTime'];
      delete object['followUpDateTime'];
    }

    if (firstValue != undefined) {

      finalObject['secondaryLeadStatus'] = firstValue;
    }

    object = finalObject

    console.log(finalObject);

    this.textSave = "Processing";

    this.leadService.editLead(object, this.leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.textSave = "Save";
          this.getAllLeadDetails(this.leadId);
          this.getAllLeadActivity(this.leadId);
          this.closePopup.emit(true)

        } else {
          this.textSave = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.textSave = "Save";
      });


  }

  private formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  private parseFollowUpDateTime(dateTimeStr: any): { date: any; time: string } {
    if (!dateTimeStr) {
      return { date: null, time: '' };
    }
    const str = String(dateTimeStr).trim();
    if (!str) {
      return { date: null, time: '' };
    }

    let parsedDate: Date | null = null;
    let timeStr = '';

    if (str.includes(' ') || str.includes('T')) {
      const parts = str.split(/[ T]/);
      const datePart = parts[0];
      const timePart = parts[1];

      parsedDate = new Date(datePart);
      if (isNaN(parsedDate.getTime())) {
        parsedDate = new Date(str.replace(' ', 'T'));
      }

      if (timePart) {
        const timeSubParts = timePart.split(':');
        if (timeSubParts.length >= 2) {
          const hh = timeSubParts[0].padStart(2, '0');
          const mm = timeSubParts[1].substring(0, 2).padStart(2, '0');
          timeStr = `${hh}:${mm}`;
        }
      }
    } else {
      parsedDate = new Date(str);
    }

    if (parsedDate && isNaN(parsedDate.getTime())) {
      parsedDate = null;
    }

    return { date: parsedDate, time: timeStr };
  }

  private toTime24(timeStr: string): string {
    if (!timeStr) return '';
    const trimmed = String(timeStr).trim();
    const match12 = trimmed.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)$/i);
    if (match12) {
      let hours = parseInt(match12[1], 10);
      const minutes = match12[2];
      const period = match12[3].toUpperCase();
      if (period === 'PM' && hours < 12) hours += 12;
      if (period === 'AM' && hours === 12) hours = 0;
      return `${String(hours).padStart(2, '0')}:${minutes}`;
    }
    const match24 = trimmed.match(/^(\d{1,2}):(\d{2})/);
    if (match24) {
      return `${match24[1].padStart(2, '0')}:${match24[2]}`;
    }
    return '';
  }

  private getCombinedFollowUpDateTime(): string | null {
    if (this.currentStatusName === 'Not intrested') {
      return null;
    }
    const dateVal = this.firstFormGroup.value.followUpDate || this.firstFormGroup.value.followUpDateTime;
    if (!dateVal) {
      return null;
    }
    const formattedDate = this.formatDate(dateVal);
    if (!formattedDate) {
      return null;
    }
    let timeVal = (this.firstFormGroup.value.followUpTime || '').trim();
    if (timeVal) {
      const timeParts = timeVal.split(':');
      const hh = (timeParts[0] || '00').padStart(2, '0');
      const mm = (timeParts[1] || '00').substring(0, 2).padStart(2, '0');
      const ss = timeParts[2] ? timeParts[2].substring(0, 2).padStart(2, '0') : '00';
      return `${formattedDate} ${hh}:${mm}:${ss}`;
    }
    return `${formattedDate} 00:00:00`;
  }


  createNote(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "title": " Add Notes to your lead!",
          "ownerId": this.ownerId
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "title": " Add Notes to your lead!",
          "ownerId": this.ownerId
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }

      });
    }
  }

  createDocument(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 2,
          "title": "Attach Document",
          "ownerId": this.ownerId
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 2,
          "title": "Attach Document",
          "ownerId": this.ownerId
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }

      });
    }
  }

  createPayment(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 3,
          "title": "Payment",
          "ownerId": this.ownerId
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 3,
          "title": "Payment",
          "ownerId": this.ownerId
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }

      });
    }
  }


  sortParam1: any = 'noteId' + "," + Constant.Dsc;
  sortParam2: any = 'id' + "," + Constant.Dsc;

  getLeadNote(leadId) {

    this.crmNoteService.getAllNoteByLeadId(leadId, "1").subscribe(
      res => {
        this.noteList = res;

        //    console.log(this.noteList);


      },
      error => {

      }
    )
  }


  @ViewChild('delete') delete: TemplateRef<any>;

  deleteLeadDialog(activityId) {

    this.activityId = activityId;
    let dialogRef = this.dialog.open(this.delete, {
      width: '350px',
      disableClose: true,

    });
    dialogRef.disableClose = true;
  }


  submit() {
    this.deleteAllLead(this.id);
    this.dialog.closeAll();
    this.init = false;
    this.getAllLeadActivity(this.leadId);
  }

  resourcePrivilege: any;
  spinner: boolean = false;

  deleteAllLead(id: any) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.leadActivityService.deleteByLeadActivityId(this.activityId).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getAllLeadActivity(this.leadId);
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })
  }


  @ViewChild('makeConnection') makeConnection: TemplateRef<any>;

  makeCallConnections(LeadDetailsObject) {
    let dialogRef = this.dialog.open(CallListComponent, {
      width: '350px',
      disableClose: true,
      data: { data: LeadDetailsObject }

    });
    dialogRef.disableClose = true;

  }

  makeCall() {
    if (this.textCall == 'Call') {
      this.spinner = true;
      this.leadActivityService.makeCall(this.LeadDetailsObject).subscribe(
        response => {
          this.spinner = false;
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
            this.dialog.closeAll();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.dialog.closeAll();
        },
        error => {
          this.spinner = false;
        });

    }

  }


  //leadStatus

  filtereddropdownTypeList: any;

  defaultLeadStatus: FormControl = new FormControl('');

  dropdownTypeList: any;
  dropdownList: any;
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();


  getLeadDropDownList() {

    this.leadStatusService.getAllLeadStatusDropDownCache().subscribe(
      res => {
        this.dropdownList = res;
        this.dropdownTypeList = res;
        this.filtereddropdownTypeList = this.dropdownTypeList;
      },
      error => {
      })
  }


  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }


  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(status => status['statusName'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }


  object = {
    "entity_type": "Lead",
    "entity_id": "1",
    "entity_name": "yesh",
    "entity_number": "893972994",
    "tenant_id": " Account Id",
    "user_email": "calsoft_agent01@doocti.com",
    "user_id": "1",
    "user_number": "362"
  }

  @ViewChild('myFrame') myFrame: ElementRef;
  callANumber(number) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));

    console.log(number);

    const postData = {
      "entity_type": "Lead",
      "entity_id": this.LeadDetailsObject.entityId,
      "entity_name": this.LeadDetailsObject.name,
      "entity_number": this.LeadDetailsObject.phoneNumber.toString(),
      "tenant_id": "Account Id",
      "user_email": this.LeadDetailsObject.ownerEmail,
      "user_id": this.LeadDetailsObject.ownerId,
      "user_number": "362"
    };

    iframeWindow.postMessage(postData, 'https://crm-app.doocti.com');
  }


  receiveMessage(event: MessageEvent) {

    if (event.origin !== 'https://crm-app.doocti.com') {
      return;
    }

    console.log('Received message from iframe:', event.data);
  }

  opendialCall() {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
  }

  dialClose() {
    document.getElementById("mydailer").style.display = "none";
    this.dialerShow = false;
  }

  isMinimized = false;

  minimizeToggle() {
    this.isMinimized = !this.isMinimized;
  }


  download(value) {
    let smallImage = "/coursepdf/" + value;
    this.productService.downloadPdf(smallImage).subscribe(
      data => {
        downloads(data);
      },
    )
  }

  back() {
    this.location.back()
  }

  navigateToInvoice(LeadDetailsObject) {

    this.leadId = LeadDetailsObject.entityId
    this.router.navigate([`/invoice-generation/${this.leadId}`])
  }


  onFormSubmitted(event) {



    this.finalValueForm = event;


  }

  createDynamicForm(event, formGroupId, statusId, statusName) {

    if (event.isUserInput != false) {

      this.patchValues.LeadStatus = statusId;

      this.currentStatusName = statusName;


      if (this.currentStatusName == 'Not intrested') {
        this.firstFormGroup.get('followUpDate')?.clearValidators();
        this.firstFormGroup.patchValue({
          followUpDate: null,
          followUpTime: '',
          followUpDateTime: ''
        });
      } else {
        this.firstFormGroup.get('followUpDate')?.setValidators([Validators.required]);
        this.firstFormGroup.patchValue({
          followUpDate: this.firstFormGroup.value.followUpDate,
          followUpTime: this.firstFormGroup.value.followUpTime,
          followUpDateTime: this.firstFormGroup.value.followUpDateTime
        });
      }
      this.firstFormGroup.get('followUpDate')?.updateValueAndValidity();

      this.formInit = false;

      this.getcreateDynamicForm(formGroupId)
    }

  }

  getcreateDynamicForm(formGroupId) {

    this.getFormArray(formGroupId)

  }


  regConfig: any[] = [];

  getFormArray(formGroupId) {
    this.init = false;
    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe((data) => {


      let value: any = data

      if (value.length > 0) {
        this.regConfig = value;
        this.init = true;
        this.newType = 2;
        this.formInit = true;

        this.changeDetector.detectChanges();
      } else {
        console.log("No form fields found for this Form Group ID");
      }


    });
  }



  toggleFavorite(leadData: any): void {


    leadData.favourite = leadData.favourite == 1 ? 0 : 1;
    let updatedLeadEntity = {

      entityId: leadData.entityId,
      favourite: leadData.favourite

    }
    this.leadService.editLead(updatedLeadEntity, leadData.entityId).subscribe(
      response => {

      },
      error => {


      }
    );
  }

  submitone() {

    this.text = 'Processing';

    let updatedLeadEntity = {

      entityId: this.leadId,
      priority: this.firstFormGroup.value.priority

    }
    this.leadService.editLead(updatedLeadEntity, this.leadId).subscribe(
      response => {
        this.closePopup.emit(true);
        this.text = 'Submit';
      },
      (err) => {
        this.text = 'Submit';
      }
    );


  }








  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}

